import React, { useState, useEffect } from "react";
import Switch from "./switchTheme";
import "../style/navbar.css";
import { Link } from "react-router-dom";
import { setTheme, initializeTheme, themeTime } from "../logic/theme";
import { ReactComponent as LogoBlack } from "../mediaSvg/logoBlack.svg";
import { ReactComponent as LogoWhite } from "../mediaSvg/logoWhite.svg";
import { ReactComponent as LogoShortBlack } from "../mediaSvg/logoShortBlack.svg";
import { ReactComponent as LogoShortWhite } from "../mediaSvg/logoShortWhite.svg";

function Navbar() {
  const [popup, setPopup] = useState(false);
  const [position, setPosition] = useState(0);
  const [logoTheme, setLogoTheme] = useState("day");
  const [dinamicClass, setdinamicClass] = useState("cirlceLeft");

  useEffect(() => {
    initializeTheme(); // Imposta il tema iniziale all'avvio
    const savedTheme = localStorage.getItem("theme") || "day";
    // const savedThemeDinamic = localStorage.getItem("theme") || "circleLeft";
    setLogoTheme(savedTheme);
    // setdinamicClass(savedThemeDinamic);
  }, []);

  // function to change position o select theme
  function clickSwitch(newPosition) {
    setPosition(newPosition);
  }

  // function to change color logo
  useEffect(() => {
    let newTheme;
    let dinamicClass;
    if (position === 0) {
      newTheme = "day";
      dinamicClass = "circleLeft";
      console.log("left class");
    } else if (position === 50) {
      newTheme = "auto";
      dinamicClass = "circleCenter";
      console.log("center class");
    } else if (position === 100) {
      newTheme = "dark";
      dinamicClass = "circleRight";
      console.log("right class");
    }
    setLogoTheme(newTheme);
    setTheme(newTheme);
    setdinamicClass(dinamicClass);
  }, [position]);

  // funzione in forse, da mettere in test -----<
  useEffect(() => {
    if (logoTheme === "auto") {
      const currentTheme = themeTime();
      setLogoTheme(currentTheme);
    }
  }, [logoTheme]);
  // funzione in forse, da mettere in test -----<

  // function to open and close popup
  function openPopup() {
    setPopup(true);
  }
  function closePopup() {
    setPopup(false);
  }

  return (
    <nav className="navContainer">
      <Link className="noDecoration link" to={"weather"}>
        <h4 className="btnWeather">Weather</h4>
        <div className="ghost"></div>
      </Link>
      <Link className="noDecoration" to={"/"}>
        <div className="logoContainer">
          {logoTheme === "dark" ? (
            <>
              <LogoWhite className="logoNavBigScreen" />
              <LogoShortWhite className="logoNavSmallScreen" />
            </>
          ) : (
            <>
              <LogoBlack className="logoNavBigScreen" />
              <LogoShortBlack className="logoNavSmallScreen" />
            </>
          )}
        </div>
      </Link>
      {/* <img
        className="switchImg"
        src="/media/icons/switch2.png"
        alt=""
        onClick={openPopup}
      /> */}

      {/* TEST */}
      {/* <div className={`switch ${dinamicClass}`} onClick={openPopup}> */}
      <div className="switch" onClick={openPopup}>
        <div className={`circleSwitch ${dinamicClass}`}></div>
      </div>
      <Switch
        close={closePopup}
        popup={popup}
        switchBtn={clickSwitch}
        position={position}
      />
    </nav>
  );
}

export default Navbar;
